import { render, staticRenderFns } from "./UserEditEmpType.vue?vue&type=template&id=670dfa2a&"
import script from "./UserEditEmpType.vue?vue&type=script&lang=js&"
export * from "./UserEditEmpType.vue?vue&type=script&lang=js&"
import style0 from "./UserEditEmpType.vue?vue&type=style&index=0&id=670dfa2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports